import React from 'react'
import BranchSelection from '../../components/BranchSelection'
import AnimatedPage from '../../components/Animation/AnimatedPage'

export default function BranchSelectionComponent({ id, handleVerify, myInfo, email }) {

    return (
        <AnimatedPage>
            <div className="opacity: 1; transform: none;">
                <div class="w-full flex flex-col items-center h-screen shadow-s1">
                    <div class="mx-auto top-[15%] absolute">
                        <img loading="lazy" decoding="async" src="/images/SkuTeq-Logo.svg" alt="product-logo" class="mx-auto" />
                        <div className="login-section mx-auto">
                            <div class="w-[350px]">
                                <p class="text-center pt-[33px] text-xl font-semibold text-[#031624] resetPassword-errShow">
                                    Select Branch
                                </p>
                                <div class="mx-auto">
                                    <div class="w-[350px]">
                                        <p class="pt-4 text-[#031624] text-center">
                                            Select the Branch you want to manage.
                                        </p>
                                        <BranchSelection InstitutionId={id} handleVerify={handleVerify}
                                            myInfo={myInfo} email={email} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </AnimatedPage>

    )
}
